/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.BasicQueue";
        let DocumentAutoSelectMode;
        (function (DocumentAutoSelectMode) {
            DocumentAutoSelectMode["NONE"] = "NONE";
            DocumentAutoSelectMode["FIRST"] = "FIRST";
            DocumentAutoSelectMode["SINGLE"] = "SINGLE";
        })(DocumentAutoSelectMode = Widgets.DocumentAutoSelectMode || (Widgets.DocumentAutoSelectMode = {}));
        class BasicQueueWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("BasicQueueWidgetTypeClass.createInstance()");
                    // Inherited from Basic Search - leaving in place in case the formatting is useful later - MCS
                    return new BasicQueueStandardInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                    /*
                    if (config.hasOwnProperty('Type')) {
                        switch (config.Type) {
                            case BasicQueueStandardInstanceClass.TYPE:
                            default:
                                return new BasicQueueStandardInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                        }
                    } else {
                        return new BasicQueueStandardInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                    }
                    */
                };
                this._storeStandardHtml = (htmlData) => {
                    this._log.info("BasicQueueWidgetTypeClass._storeStandardHtml()");
                    BasicQueueStandardInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicQueueWidgetTypeClass::constructor");
                if (BasicQueueStandardInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/BasicQueue/basic-queue.html', this._storeStandardHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.BasicQueueWidgetTypeClass = BasicQueueWidgetTypeClass;
        class BasicQueueStandardInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._loader = null;
                this._contextBar = null;
                this._contextLabel = null;
                this._noRecords = null;
                this._dataListHolder = null;
                this._dataList = null;
                this._dataTableHolder = null;
                this._dataTable = null;
                this._filterText = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._refreshSpan = null;
                this._filterDiv = null;
                this._registerDeselection = false;
                this._latestQueueId = 0;
                this._latestHitListQueue = null;
                this._documents = null;
                this._lastSelectedDocument = null;
                this._displayKeyNames = null;
                this._autoSelectMode = DocumentAutoSelectMode.NONE;
                this._autoSelectOnHomeView = false;
                this._reselectOnRefresh = true;
                this._suppressContextBar = false;
                this._collapseOnSelect = false;
                this._filterConstraints = [];
                this._refreshTriggers = null;
                this._useDataTable = null;
                this._defaultSlots = null;
                this._conditionalSlots = null;
                this._lastActivatedSlots = [];
                // Asynchronicity handling
                this._updatePending = false;
                this._readyForUpdates = false;
                this.presentInstance = () => {
                    this._log.info("BasicQueueStandardInstanceClass.presentInstance()");
                    this._container.innerHTML = BasicQueueStandardInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._contextBar = this._container.querySelector('#basicQueueContextBar');
                    this._contextLabel = this._container.querySelector('#basicQueueContextLabel');
                    this._noRecords = this._container.querySelector('#basicQueueNoRecords');
                    this._dataListHolder = this._container.querySelector('#basicQueueDataListHolder');
                    this._dataTableHolder = this._container.querySelector('#basicQueueDataTableHolder');
                    this._filterText = this._container.querySelector('#basicQueueFilter');
                    this._showFilterSpan = this._container.querySelector('.basicQueueShowFilter');
                    this._hideFilterSpan = this._container.querySelector('.basicQueueCancelFilter');
                    this._refreshSpan = this._container.querySelector('#basicQueueRefresh');
                    this._filterDiv = this._container.querySelector('.widget__filter');
                    let resizableElement = this._container.querySelector('.' + Widgets.WIDGET_SIZE_TARGET_CLASS);
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#basicQueueWidgetTitle'), 'STR_WPT_QUEUE_CONTENTS');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#basicQueueLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#basicQueueNoRecordsLabel'), 'STR_WPT_QUEUE_EMPTY');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._showFilterSpan, 'title', 'STR_WPT_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._hideFilterSpan, 'title', 'STR_WPT_HIDE_FILTER');
                    this._core.Helper.setElementTranslationAttribute(this._refreshSpan, 'title', 'STR_WPT_REFRESH');
                    // Add event listener for options (filter) and clear filter icon
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showFilterSpan.addEventListener('click', this._showFilter);
                    this._hideFilterSpan.addEventListener('click', this._hideFilter);
                    this._refreshSpan.addEventListener('click', this._refreshClicked);
                    // this._container.querySelector('#basicQueueReload').addEventListener('click', this.refresh);
                    //this._container.querySelector('#basicQueueNoRecordsReload').addEventListener('click', this.refresh);
                    this._container.querySelector('.basicQueueClearFilter').addEventListener('click', this._clearFilter);
                    let maxHeightPx = null;
                    let maxHeight = window.getComputedStyle(resizableElement).maxHeight;
                    if (maxHeight != "none") {
                        // expecting max-height set in pixels
                        maxHeightPx = parseInt(maxHeight, 10);
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("using max-height: " + maxHeightPx);
                        }
                    }
                    let listConfig = {
                        SelectItemCallback: this._docSelected
                    };
                    this._dataList = new Widgets.ComponentDataList(this._core, this._dataListHolder, this, listConfig);
                    this._dataList.present();
                    this._dataTable = new Widgets.ComponentDataTable(this._core, this._dataTableHolder, this, maxHeightPx);
                    this._dataTable.present();
                    this._getQueues();
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("BasicQueueStandardInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("BasicQueueStandardInstanceClass._callErrorHandler()");
                    this.addError(message);
                    this._core.Functions.hideElement(this._loader);
                };
                this._getQueues = () => {
                    this._log.info("BasicQueueStandardInstanceClass._getQueues()");
                    this._core.Functions.hideElement(this._container.querySelector('#basicQueueNoRecords'));
                    this._core.Functions.showElement(this._loader);
                    this._core.OBHelper.LoadQueues(this._storeQueues);
                };
                this._storeQueues = () => {
                    this._log.info("BasicQueueStandardInstanceClass._storeQueues()");
                    this._readyForUpdates = true;
                    this._doSearch();
                };
                this._doSearch = () => {
                    this._log.info("BasicQueueStandardInstanceClass._doSearch()");
                    if (this._updatePending) {
                        this.updateSearch(this._latestQueueId);
                    }
                    else {
                        let config = this._config;
                        if (config.hasOwnProperty('QueueId')) {
                            this.updateSearch(config.QueueId);
                        }
                        else if (config.hasOwnProperty('Queue')) {
                            this.updateSearch(config.Queue);
                        }
                        else {
                            this._displayResult({});
                        }
                    }
                };
                // Full update including possible change of queue
                this.updateSearch = (query) => {
                    this._log.info("BasicQueueStandardInstanceClass.updateSearch()");
                    this._clearErrors();
                    let queueId = 0;
                    if (typeof query !== 'object')
                        queueId = query;
                    else {
                        let targetQueue = this._core.OBHelper.Queues.find(queue => ((queue.Name == query.QueueName) && (queue.LifeCycle.Name == query.Lifecycle)));
                        if (targetQueue)
                            queueId = targetQueue.Id;
                    }
                    if (queueId == 0) {
                        this._core.Functions.hideElement(this._loader);
                        this._core.Functions.showElement(this._noRecords);
                        return;
                    }
                    this._latestQueueId = queueId;
                    if (this._readyForUpdates) {
                        this._core.Functions.showElement(this._loader);
                        this._core.Loader.genericServiceCall(`/Workflow.svc/rest/GetQueueDocuments/${queueId}`, this._displayResult, this._callErrorHandler, this._callFailedHandler);
                    }
                    else {
                        this._updatePending = true;
                    }
                };
                this._refreshClicked = (event) => {
                    this.refresh();
                };
                // Refresh list on existing queue
                this.refresh = () => {
                    this._log.info("BasicQueueStandardInstanceClass.refresh()");
                    if (!this._readyForUpdates)
                        return;
                    if (this._latestQueueId > 0) {
                        this._clearErrors();
                        this._core.Functions.showElement(this._loader);
                        this._core.Loader.genericServiceCall(`/Workflow.svc/rest/GetQueueDocuments/${this._latestQueueId}`, this._displayResult, this._callErrorHandler, this._callFailedHandler);
                    }
                };
                this.setDisplayKeys = (keyNames, forceRefresh) => {
                    this._log.info("BasicQueueStandardInstanceClass.setDisplayKeys()");
                    // You can have a maximum of three and count yourself lucky
                    this._displayKeyNames = [];
                    let maxEntries = Math.min(3, keyNames.length);
                    if (keyNames.length > 0) {
                        for (let i = 0; i < maxEntries; i++)
                            this._displayKeyNames.push(keyNames[i]);
                    }
                };
                this.returnedToHomepage = () => {
                    this._log.info("BasicQueueStandardInstanceClass.returnedToHomepage()");
                    super.returnedToHomepage();
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                };
                this._displayResult = (response) => {
                    this._log.info("BasicQueueStandardInstanceClass._displayResult()");
                    this._core.Functions.hideElement(this._loader);
                    this._core.Functions.hideElement(this._contextBar);
                    this._core.Functions.hideElement(this._dataListHolder);
                    this._core.Functions.hideElement(this._dataTableHolder);
                    this._useDataTable = false;
                    let previousDocStillAvailable = false;
                    let firstDocId = null;
                    let previousDocId = null;
                    let firstDocElement = null;
                    let previousDocElement = null;
                    let documentCount = 0;
                    // ResponseWorkflow is a little busy, so we need to drill down
                    let queue = null;
                    if (response.hasOwnProperty('Workflows')) {
                        queue = response.Workflows.find(q => q.Id = this._latestQueueId);
                        if (queue == null) {
                            this.addError(`Queue search did not return record for indicated queue (ID: ${this._latestQueueId})`);
                        }
                    }
                    // Housekeeping
                    if (queue != null) {
                        this._latestHitListQueue = queue;
                        this._contextLabel.innerHTML = this._latestHitListQueue.Name;
                        if (!this._suppressContextBar)
                            this._core.Functions.showElement(this._contextBar);
                    }
                    if ((queue != null) && queue.hasOwnProperty('Documents') && (queue.Documents.length > 0)) {
                        if (this._filterConstraints.length == 0)
                            this._documents = queue.Documents;
                        else
                            this._documents = this._core.OBHelper.filterDocumentList(queue.Documents, this._filterConstraints, null);
                        let documentsLength = this._documents.length;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Query of queue ${queue.Id} got ${documentsLength} documents`);
                        }
                        this._core.Functions.hideElement(this._noRecords);
                        if (this._displayKeyNames.length > 0) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using data table");
                            }
                            this._useDataTable = true;
                            this._core.Functions.showElement(this._dataTableHolder);
                            let columns = [];
                            let docNameSetting = {
                                Title: this._core.Locale.getTranslation('STR_WPT_NAME')
                            };
                            columns.push(docNameSetting);
                            this._displayKeyNames.forEach(keyName => {
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace(`Adding column header for key ${keyName}`);
                                }
                                let cellText = keyName;
                                cellText = cellText.replace(WPTNamespace.Utilities.KW_NAME_DOC_TYPE, 'STR_WPT_TYPE');
                                let columnSetting = {
                                    Title: this._core.Locale.getTranslation(cellText)
                                };
                                columns.push(columnSetting);
                            });
                            // Insert a hidden column for the original document sort order to try to mitigate autoselect in the wrong place
                            columns.unshift({ Title: 'IntialOrder', FilterType: 'Text', Orderable: true, Visible: false });
                            let rows = [];
                            for (let i = 0; i < documentsLength; i++) {
                                let doc = this._documents[i];
                                if ((this._lastSelectedDocument != null) && (doc.ItemNum == this._lastSelectedDocument.ItemNum)) {
                                    previousDocStillAvailable = true;
                                }
                                let metaValues = [];
                                let rowValues = [];
                                let rowData = {
                                    Values: rowValues,
                                    Metadata: metaValues,
                                    ClickCallback: this._docClicked
                                };
                                let metadata = {
                                    Name: 'data-id',
                                    Value: doc.ItemNum.toString(10)
                                };
                                metaValues.push(metadata);
                                // Insert count value - required to keep initial sort in line
                                rowValues.push({ Value: i, Display: i.toString(10), Sort: i, Filter: i.toString(10), PreventSanitising: true });
                                let docNameValue = {
                                    Value: doc.Name,
                                    Display: doc.Name,
                                    Sort: doc.Name,
                                    Filter: doc.Name
                                };
                                rowValues.push(docNameValue);
                                let pulledKeys = this._core.OBHelper.GetMultipleKeywordValues(doc, this._displayKeyNames, true);
                                this._displayKeyNames.forEach(keyName => {
                                    let value = "";
                                    if (pulledKeys[keyName]) {
                                        value = pulledKeys[keyName];
                                    }
                                    let keyValue = {
                                        Value: value,
                                        Display: value,
                                        Sort: value,
                                        Filter: value
                                    };
                                    rowValues.push(keyValue);
                                });
                                rows.push(rowData);
                                documentCount++;
                                if (!firstDocId)
                                    firstDocId = doc.ItemNum.toString(10);
                            }
                            let tableData = {
                                Columns: columns,
                                Rows: rows
                            };
                            this._dataTable.displayData(tableData);
                            if (firstDocId) {
                                firstDocElement = this._dataTableHolder.querySelector('tr[data-id="' + firstDocId + '"]');
                                firstDocId = null;
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("first doc element selected: " + firstDocElement);
                                }
                            }
                            if (previousDocStillAvailable) {
                                previousDocElement = this._dataTableHolder.querySelector('tr[data-id="' + this._lastSelectedDocument.ItemNum + '"]');
                                if (this._log.isTraceEnabled()) {
                                    this._log.trace("previous doc element selected: " + previousDocElement);
                                }
                            }
                        }
                        else {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("using simple table");
                            }
                            this._core.Functions.showElement(this._dataListHolder);
                            let listData = {
                                Items: []
                            };
                            for (let i = 0; i < documentsLength; i++) {
                                let doc = this._documents[i];
                                let itemData = {
                                    Id: doc.ItemNum.toString(10),
                                    DisplayName: doc.Name
                                };
                                listData.Items.push(itemData);
                                documentCount++;
                                if (!firstDocId)
                                    firstDocId = itemData.Id;
                                if ((this._lastSelectedDocument != null) && (doc.ItemNum == this._lastSelectedDocument.ItemNum)) {
                                    previousDocStillAvailable = true;
                                    previousDocId = itemData.Id;
                                }
                            }
                            this._dataList.displayData(listData);
                        }
                    }
                    else {
                        this._core.Functions.showElement(this._noRecords);
                        this._documents = [];
                    }
                    this._doFilter();
                    if (!previousDocStillAvailable) {
                        // If the previous document is no longer in the list, tell someone
                        if (this._lastSelectedDocument != null)
                            this._docDeselected();
                        this._lastSelectedDocument = null;
                        // If we are set to auto-select, fire that event
                        if (firstDocElement || firstDocId) {
                            if ((this._autoSelectMode == DocumentAutoSelectMode.FIRST) || ((this._autoSelectMode == DocumentAutoSelectMode.SINGLE) && (documentCount == 1))) {
                                if ((this._currentLayout != WPTNamespace.Navigation.HOME_VIEW_NAME) || this._autoSelectOnHomeView) {
                                    if (this._useDataTable) {
                                        // Create our own click event and dispatch
                                        let event = new MouseEvent('click');
                                        firstDocElement.dispatchEvent(event);
                                    }
                                    else {
                                        this._docSelected(firstDocId);
                                    }
                                }
                            }
                        }
                        else
                            this._core.Widgets.setWidgetCollapseStateDirect(this, true);
                    }
                    else {
                        if ((this._lastSelectedDocument != null) && this._reselectOnRefresh) {
                            if (this._useDataTable) {
                                let event = new MouseEvent('click');
                                previousDocElement.dispatchEvent(event);
                            }
                            else {
                                this._docSelected(previousDocId);
                            }
                        }
                    }
                };
                this._showFilter = () => {
                    this._log.info("BasicQueueStandardInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    if (this._useDataTable) {
                        this._dataTable.showFilterRow();
                    }
                    else {
                        this._core.Functions.showElement(this._filterDiv);
                        this._filterText.focus();
                    }
                };
                this._hideFilter = () => {
                    this._log.info("BasicQueueStandardInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    if (this._useDataTable) {
                        this._dataTable.hideFilterRow();
                    }
                    else {
                        this._core.Functions.hideElement(this._filterDiv);
                        this._clearFilter();
                    }
                };
                this._clearFilter = () => {
                    this._log.info("BasicQueueStandardInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    this._log.info("BasicQueueStandardInstanceClass._doFilter()");
                    if (!this._useDataTable) {
                        let filterText = this._filterText.value;
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("filtering with: " + filterText);
                        }
                        this._dataList.filterItems(filterText);
                    }
                };
                this._docSelected = (id) => {
                    this._log.info("BasicQueueStandardInstanceClass._docSelected()");
                    let config = this._config;
                    let docId = Number(id);
                    this._lastSelectedDocument = this._documents.find(doc => doc.ItemNum == docId);
                    // Update the selection UI
                    if (!this._useDataTable) {
                        this._dataList.clearItemSelection();
                        this._dataList.selectItem(id);
                    }
                    if (this._collapseOnSelect) {
                        this._core.Widgets.setWidgetCollapseStateDirect(this, false);
                    }
                    // At this point we need to check whether we have a normal document or something set up in our relationship context
                    let currentConditional = null;
                    for (let i = 0; i < this._conditionalSlots.length; i++) {
                        if (this._core.Context.evaluateSelectionCriteria(this._conditionalSlots[i].Criteria, this._lastSelectedDocument)) {
                            currentConditional = this._conditionalSlots[i];
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`Conditional activation set against slots ${currentConditional.ReferenceSlots}`);
                            }
                            break;
                        }
                    }
                    // If conditional has no slots, we don't publish!
                    if (!currentConditional || (currentConditional.hasOwnProperty('Slots') && (currentConditional.Slots.length > 0))) {
                        // Tell the system we've got a selection
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                        navEvent.ActivationID = docId;
                        navEvent.PrimaryContext = this._lastSelectedDocument;
                        navEvent.AdditionalContext["SourceQueueID"] = this._latestQueueId;
                        navEvent.AdditionalContext["SourceQueueRecord"] = this._core.OBHelper.Queues.find(q => q.Id == this._latestQueueId);
                        navEvent.Slots = (currentConditional) ? currentConditional.Slots : this._defaultSlots;
                        this._lastActivatedSlots = [];
                        this._lastActivatedSlots.push(...navEvent.Slots);
                        // Set default layout, but check if we've had an alternative requested against the instance
                        let targetLayoutName = "Workflow";
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                        // Add transfer widgets if we are moving
                        if (targetLayoutName != this._currentLayout) {
                            if (config.hasOwnProperty("ForwardOtherWidgets")) {
                                navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                            }
                        }
                        navEvent.Layout = targetLayoutName;
                        // We need to be called back if we are running a conditional
                        if (currentConditional && currentConditional.FlexQuery && currentConditional.hasOwnProperty('ReferenceSlots') && (currentConditional.ReferenceSlots.length > 0)) {
                            this._log.trace("Conditional slot/reference document handling requires callback - setting on context.");
                            navEvent.FinalCallbacks.push(this._activateWithReferenceDoc.bind(this, currentConditional));
                        }
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._activateWithReferenceDoc = (conditional, context) => {
                    this._log.info("BasicQueueStandardInstanceClass._activateWithReferenceDoc()");
                    if (conditional && conditional.FlexQuery && conditional.hasOwnProperty('ReferenceSlots') && (conditional.ReferenceSlots.length > 0)) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`Building flex request from ${conditional.FlexQuery} for slots ${conditional.ReferenceSlots}`);
                        }
                        let requestSearch = this._core.OBHelper.flexDefinitionToRequest(conditional.FlexQuery);
                        requestSearch.ReturnQueues = false;
                        this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._referenceDocReturned.bind(this, conditional), {}, this._callErrorHandler, this._callFailedHandler);
                    }
                };
                this._referenceDocReturned = (condition, response) => {
                    this._log.info("BasicQueueStandardInstanceClass._referenceDocReturned()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        if (response.Documents.length > 1)
                            console.warn("BasicQueue related search returned multiple documents, using first.");
                        let doc = response.Documents[0];
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_SELECTED);
                        navEvent.ActivationID = doc.ItemNum;
                        navEvent.PrimaryContext = doc;
                        navEvent.Slots = condition.ReferenceSlots;
                        this._lastActivatedSlots.push(...navEvent.Slots);
                        // TODO: this might create some timing issues if the layout was changed by the original document selection
                        navEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    else
                        console.warn("BasicQueue related search returned no documents.");
                };
                this._docClicked = (event) => {
                    this._log.info("BasicQueueStandardInstanceClass._docClicked()");
                    let clickedItem = event.currentTarget;
                    let docId = clickedItem.getAttribute('data-id');
                    // Update the selection UI, since this is only used for data table, we do it directly
                    this._dataTable.clearRowSelection(true);
                    clickedItem.classList.add(Widgets.WIDGET_SELECTED_CLASS);
                    this._docSelected(docId);
                };
                this._docDeselected = () => {
                    this._log.info("BasicQueueStandardInstanceClass._docDeselected()");
                    if (!this._registerDeselection)
                        return;
                    let config = this._config;
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_DESELECTED);
                    navEvent.ActivationID = this._lastSelectedDocument.ItemNum;
                    navEvent.PrimaryContext = this._lastSelectedDocument;
                    navEvent.AdditionalContext["SourceQueueID"] = this._latestQueueId;
                    // Note: queues from hit list call don't have actions defined, so need to take from our main queue data
                    navEvent.AdditionalContext["SourceQueueRecord"] = this._core.OBHelper.Queues.find(q => q.Id == this._latestQueueId);
                    navEvent.Slots.push(...this._lastActivatedSlots);
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "Workflow";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    this._lastSelectedDocument = null;
                    this._lastActivatedSlots = [];
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("BasicQueueStandardInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._useDataTable = false;
                let conf = this._config;
                if (conf.hasOwnProperty("RegisterDeselection") && (conf.RegisterDeselection == true))
                    this._registerDeselection = true;
                this._displayKeyNames = [];
                if (conf.hasOwnProperty('DisplayKeys')) {
                    // You can have a maximum of three and count yourself lucky
                    let maxEntries = Math.min(3, conf.DisplayKeys.length);
                    for (let i = 0; i < maxEntries; i++)
                        this._displayKeyNames.push(conf.DisplayKeys[i]);
                }
                else {
                    // Default to type initially - this isn't mandated later
                    this._displayKeyNames.push(WPTNamespace.Utilities.KW_NAME_DOC_TYPE);
                }
                if (conf.hasOwnProperty('AutoSelectMode'))
                    this._autoSelectMode = DocumentAutoSelectMode[conf.AutoSelectMode];
                if (conf.hasOwnProperty('AutoSelectOnHomeView') && conf.AutoSelectOnHomeView)
                    this._autoSelectOnHomeView = true;
                if (conf.hasOwnProperty('SuppressContextBar') && conf.SuppressContextBar)
                    this._suppressContextBar = true;
                if (conf.hasOwnProperty('ReselectOnRefresh') && (conf.ReselectOnRefresh != null))
                    this._reselectOnRefresh = conf.ReselectOnRefresh;
                if (conf.hasOwnProperty('CollapseOnSelect') && (conf.CollapseOnSelect != null))
                    this._collapseOnSelect = conf.CollapseOnSelect;
                if (conf.hasOwnProperty('DocumentFilter') && (conf.DocumentFilter != null))
                    this._filterConstraints = conf.DocumentFilter;
                else
                    this._filterConstraints = [];
                if (config.hasOwnProperty('RefreshTriggers') && conf.RefreshTriggers && (conf.RefreshTriggers.length > 0))
                    this._refreshTriggers = conf.RefreshTriggers;
                else
                    this._refreshTriggers = [];
                this._core.Functions.addDefaultsToTriggerEvents(this._refreshTriggers);
                if (conf.hasOwnProperty('ActivateIntoSlots') && (conf.ActivateIntoSlots != null) && (conf.ActivateIntoSlots.length > 0))
                    this._defaultSlots = conf.ActivateIntoSlots;
                else
                    this._defaultSlots = [WPTNamespace.Utilities.PRIMARY_SLOT_KEY, WPTNamespace.Utilities.WF_USER_VIEW_DOC_KEY];
                if (conf.hasOwnProperty('ConditionalSlots') && (conf.ConditionalSlots != null))
                    this._conditionalSlots = conf.ConditionalSlots;
                else
                    this._conditionalSlots = [];
            }
            set AutoSelectMode(value) {
                this._autoSelectMode = value;
            }
            set CollapseOnSelect(value) {
                this._collapseOnSelect = value;
            }
            get ConditionalreferenceSelections() {
                return this._conditionalSlots;
            }
            set ConditionalreferenceSelections(value) {
                this._conditionalSlots = value;
            }
            activate(context) {
                this._log.info("BasicQueueStandardInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_QUEUE_SELECTED:
                        if ((context.ActivationID) && (context.ActivationID == this._latestQueueId))
                            this.refresh();
                        else
                            this.updateSearch(context.ActivationID);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_ACTION_FIRED:
                        this.refresh();
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.WORKFLOW_NO_ITEMS:
                        this._core.Functions.hideElement(this._loader);
                        this._core.Functions.showElement(this._noRecords);
                        this._core.Functions.hideElement(this._dataListHolder);
                        this._core.Functions.hideElement(this._dataTableHolder);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.RETURNED_TO_HOME_VIEW:
                        this._updatePending = false;
                        this._lastSelectedDocument = null;
                        this._doSearch();
                        break;
                    default:
                        if (this._refreshTriggers.length > 0) {
                            // Loop with iterator so we can escape when necessary
                            for (let i = 0; i < this._refreshTriggers.length; i++) {
                                let trigger = this._refreshTriggers[i];
                                if (this._core.Functions.triggerEventMatches(trigger, context)) {
                                    this.refresh();
                                    // Only trigger once
                                    return;
                                }
                                else {
                                    continue;
                                }
                            }
                        }
                        break;
                }
            }
        }
        BasicQueueStandardInstanceClass.TYPE = 'Standard';
        BasicQueueStandardInstanceClass.HtmlData = null;
        Widgets.BasicQueueStandardInstanceClass = BasicQueueStandardInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
